import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Col, Row } from 'react-flexbox-grid';
import Button from '@saucelabs/sl-component-buttons';
import { OverlayTrigger } from '@saucelabs/sl-component-overlay';
import { records as buildsRecords } from '@saucelabs/sl-module-builds';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { buildIconMap } from '@saucelabs/sl-component-build';

import BadgeConfiguratorModal from './BadgeConfiguratorModal';
import OwnersPopover from './OwnersPopover';
import StatusPopover from './StatusPopover';
import Styles from './List.styles';
import { constants, functions } from './../ducks/filters';


const BuildsFilters = ({
  builds,
  clearStatuses,
  openBadgeConfiguratorModal,
  owners,
  ownership,
  selectOwner,
  showOwnersFilter,
  status,
  toggleStatus,
  user,
}) => {
  const shouldRenderBadgeLogic = (
    builds.first() && builds.first().get('public') && user.isOpenSauceUser()
  );
  const owner = (
    owners
      .find((userObj) => userObj.name === ((!ownership.name && user.get('username')) || ownership.name)) ||
    functions.getUsernameFilter(ownership.name)
  );
  return (
    <Row>
      {shouldRenderBadgeLogic && (
        <BadgeConfiguratorModal
          buildId={builds.first().get('id')}
          username={user.get('username')}
        />
      )}
      <Col xs={12}>
        <Row between="xs">
          <Col
            xs={7}
          >
            {shouldRenderBadgeLogic && (
              <Button
                category="link"
                className={Styles['badge-button']}
                onClick={openBadgeConfiguratorModal}
              >
                <div>
                  <img
                    alt="Share Build Status"
                    src={`http://saucelabs.com/buildstatus/${user.get('username')}`}
                  />
                  <span className="text-link">&nbsp;Get your badge here</span>
                </div>
              </Button>
            )}
          </Col>
          <Col xs>
            <div className={Styles['filters-row']}>
              <div className={`label ${Styles['filter-text']}`}>Filter:</div>
              {showOwnersFilter && owner && (
                <div className={Styles['filter-item']}>
                  <OverlayTrigger
                    overlay={OwnersPopover({
                      username: user.get('username'),
                      owners,
                      ownership,
                      selectOwner,
                    })}
                    placement="bottom"
                    rootClose
                    trigger="click"
                  >
                    <div>
                      <span className={Styles['filter-title']}>Owner:&nbsp;</span>
                      {owner.label}
                    </div>
                  </OverlayTrigger>
                </div>
              )}
              <div className={Styles['filter-item']}>
                <OverlayTrigger
                  overlay={StatusPopover({
                    clearStatuses,
                    statusesList: constants.BUILD_STATUS_LIST,
                    status,
                    statusesIconMap: buildIconMap,
                    toggleStatus,
                  })}
                  placement="bottom"
                  rootClose
                  trigger="click"
                >
                  <div>
                    <span className={Styles['filter-title']}>Status:&nbsp;</span>
                    { status.join(', ') || 'All' }
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

BuildsFilters.propTypes = {
  builds: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(buildsRecords.BuildRecordClass).isRequired,
  ).isRequired,
  clearStatuses: PropTypes.func.isRequired,
  openBadgeConfiguratorModal: PropTypes.func.isRequired,
  owners: PropTypes.array.isRequired,
  ownership: PropTypes.object.isRequired,
  selectOwner: PropTypes.func.isRequired,
  showOwnersFilter: PropTypes.bool.isRequired,
  status: ImmutablePropTypes.list.isRequired,
  toggleStatus: PropTypes.func.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass).isRequired,
};

export default BuildsFilters;
